<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove this host booking restriction from the accommodation {{hpbr.huis_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHpbr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hpbr_encrid: null,
      hpbr: {}
    }
  },
  methods: {
    open(hpbr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hpbr/getHpbr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHpbr"
          },
          getHpbr: {
            hpbr_encrid: hpbr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hpbr = res.data.getHpbr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHpbr() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hpbr/rmHpbr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHpbr"
          },
          rmHpbr: {
            hpbr_encrid: this.hpbr.hpbr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             //this.$router.reload('/huis/onHuis/' + res.data.rmHpbr.huis_encrid); 
            //  bus.$emit("closeDialog", "reload");
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHpbr.text,
              color: res.data.rmHpbr.color
            });
            this.$emit('updateData');
            this.dialog = false;
          }
        })
    },
  }
}
</script>

